/* eslint-disable camelcase */
import React from 'react';
import { connect } from 'react-redux';
import LeadVettingPage from '../components/LeadVettingPage';
import { VettingSelectors } from '../../../Redux/modules/vetting/selectors';
import { VettingActions } from '../../../Redux/modules/vetting/actions';

const mapStateToProps = (state) => {
  return {
    vettingStage: VettingSelectors.vettingStageSelector(state),
    fields: VettingSelectors.vettingFieldsSelector(state),
    isLoading: VettingSelectors.vettingLoadingSelector(state),
  };
};
const mapDispatchToProps = {
  submitVettingStep1: VettingActions.submitVettingStep1,
  submitVettingStep2: VettingActions.submitVettingStep2,
  submitVettingStep3: VettingActions.submitVettingStep3,
  submitVettingForm: VettingActions.submitVetting,
  updateStage: VettingActions.updateStage,
  agreeToTerms: VettingActions.agreeToTerms,
  updateFields: VettingActions.updateFields,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadVettingPage);
